import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'nsp-footer',
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {}
